import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export const toStringQuestions = (questions = []) => {
  return questions.map((questionItem) => {
    const question = questionItem.title
    const answer = documentToHtmlString(questionItem.text)

    return { question, answer }
  })
}
